const allEvents = [
   {
     id: 1,
     name: "Karácsonyi Táncgála",
     date: "Dec.14 17:00",
     desc: "Rózsa művelődési ház XVIII. kerület",
     price: "2000ft/db",
   },
  // {
  //   id: 2,
  //   name: "Karácsonyi Táncgála",
  //   date: "Dec.18 17:00",
  //   desc: "Rózsa művelődési ház XVIII. kerület",
  //   price: "1000ft/db",
  // },
];

export default allEvents;
